import { coerceValueRef } from "../authContext";
import type {
  AuthDescriptor,
  HeaderEntryRef,
  HeaderEntryRefInput,
} from "../authDescriptor";

function coerceHeader(h: HeaderEntryRefInput): HeaderEntryRef {
  return { name: h.name, value: coerceValueRef(h.value), scheme: h.scheme };
}

export function headerAuth(headers: HeaderEntryRefInput[]): AuthDescriptor {
  return { type: "header", headers: headers.map(coerceHeader) };
}
